import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@codex-brightworld/icons';
import styled, { css } from 'styled-components';
import OfferEndingText from './OfferEndingText.jsx';
import translations from './translations.js';
import { futureDate } from './helpers.js';

const List = styled.ul`
  ${({
    theme
  }) => css`
    font-family: ${({ theme }) => theme.fonts.default.fontFamily}, Helvetica, Arial, Sans-Serif;
    font-size: 14px;
    line-height: 1.4;
    padding: 16px 14px;
    margin: 0;
    border-radius: 10px;
    background-color: #fff;
    border: solid 1px ${theme.colors.neutral.grey[2]};
    list-style-type: none;
  `};
`;

const ListItem = styled.li`
  display: flex;
  margin-bottom: 12px;
`;

const ListItemContainer = styled.span`
  display: inline;
`;

const VoucherIcon = styled(Icon)`
  ${({
    theme
  }) => css`
    stroke: none;
    fill: ${theme.colors.neutral.grey[2]};
    min-width: 24px;
    margin-right: 8px;
  `};
`;

const MoreInfoLink = styled.a`
  ${({
    theme
  }) => css`
    display: inline-block;
    text-decoration: none;
    color: ${theme.colors.primary.purple};
    margin: 8px 0;
    &:before {
      content: "\\00a0";
      display: inline-block;
    }
    &:hover {
      color: ${theme.colors.primary.purple};
    }
  `};
`;

const MoreOffersLink = styled.a`
  ${({
    theme
  }) => css`
    display: block;
    text-align: center;
    text-decoration: none;
    color: ${theme.colors.primary.purple};
    margin: inherit auto;
    &:hover {
      color: ${theme.colors.primary.purple};
    }
  `};
`;

export const AddedValueMessages = (props) => {
  const AVM_MAX = props.data.messageLimit ? props.data.messageLimit : 3;

  return (
    <List>
      {
        props.data.messages
          .filter((avm) => avm.simpleOffer)
          .slice(0, AVM_MAX)
          .map((avm, i) => (
            <ListItem key={i}>
              <VoucherIcon icon={'voucher'} />
              <ListItemContainer>
                <span className={'offer'}>
                  {avm.title}
                </span>
                
                {new Date(avm.to) < futureDate() &&
                  <OfferEndingText from={avm.from} to={avm.to} />}

                <MoreInfoLink
                  className={'anchor-lk'}
                  target={'_self'}
                  href={`#tab6|product-deal-offer-${i}`}
                  rel={'noreferrer'}
                >
                  {translations.moreDetails}
                </MoreInfoLink>
              </ListItemContainer>
            </ListItem>
          ))
      }
      {props.data.messages.length > AVM_MAX && (
        <li className={'more-deals'}>
          <MoreOffersLink
            className={'anchor-lk'}
            target={'_self'}
            href={`#tab6|product-deal-offer-${
              props.data.messages.length - (props.data.messages.length - AVM_MAX)
            }`}
            rel={'noreferrer'}
          >
            {props.data.messages.length === (AVM_MAX + 1) &&
              `+ ${translations.moreDealSingle}`}
            {props.data.messages.length > (AVM_MAX + 1) &&
              `+ ${props.data.messages.length - AVM_MAX} 
                ${translations.moreDealsMulti}`}
          </MoreOffersLink>
        </li>
      )}
    </List>
  );
};

AddedValueMessages.propTypes = {
  data: PropTypes.shape({
    messageLimit: PropTypes.number,
    messages: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.node,
        simpeOffer: PropTypes.bool,
        from: PropTypes.string,
        to: PropTypes.string
      })
    )
  }).isRequired
};

AddedValueMessages.displayName = 'AddedValueMessages';

export default AddedValueMessages;
